import { Input, Select } from '@/shared/ui';

const PAYER_TYPE_OPTIONS = [
  { value: 'commercial', label: 'Commercial' },
  { value: 'medicaid', label: 'Medicaid' },
  { value: 'fedvip', label: 'FEDVIP' },
];

const STRATEGY_OPTIONS = [
  { value: 'voice', label: 'Voice' },
  { value: 'staff', label: 'Staff' },
  { value: 'blocked', label: 'Blocked' },
];

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'flagged', label: 'Flagged' },
  { value: 'blocked', label: 'Blocked' },
];

export interface PayerDirectoryFieldValues {
  name: string;
  aliases: string; // comma-separated raw text — caller splits/trims on submit
  stateEntity: string;
  payerType: string;
  providerLine: string;
  verificationStrategy: string;
  status: string;
}

interface PayerDirectoryFieldsProps {
  values: PayerDirectoryFieldValues;
  onChange: (patch: Partial<PayerDirectoryFieldValues>) => void;
}

// Shared field set for both creating a new directory entry (agency "+ Add
// payer") and editing an existing one (PayerDirectoryEditor) — one form,
// one place the fields are defined.
export function PayerDirectoryFields({ values, onChange }: PayerDirectoryFieldsProps) {
  return (
    <>
      <Input
        label="Name"
        value={values.name}
        onChange={(e) => onChange({ name: e.target.value })}
        fullWidth
      />
      <Input
        label="Aliases (comma-separated)"
        value={values.aliases}
        onChange={(e) => onChange({ aliases: e.target.value })}
        fullWidth
      />
      <Input
        label="State entity"
        placeholder="CA, FED, …"
        value={values.stateEntity}
        onChange={(e) => onChange({ stateEntity: e.target.value })}
        fullWidth
      />
      <Select
        label="Payer type"
        options={PAYER_TYPE_OPTIONS}
        value={values.payerType}
        onChange={(e) => onChange({ payerType: e.target.value })}
        fullWidth
      />
      <Input
        label="Provider line"
        value={values.providerLine}
        onChange={(e) => onChange({ providerLine: e.target.value })}
        fullWidth
      />
      <Select
        label="Strategy"
        options={STRATEGY_OPTIONS}
        value={values.verificationStrategy}
        onChange={(e) => onChange({ verificationStrategy: e.target.value })}
        fullWidth
      />
      <Select
        label="Status"
        options={STATUS_OPTIONS}
        value={values.status}
        onChange={(e) => onChange({ status: e.target.value })}
        fullWidth
      />
    </>
  );
}
